export interface CameraPublicationSnapshot {
  muted: boolean;
  trackPresent: boolean;
  trackReadyState: MediaStreamTrackState | undefined;
}

export function shouldRepublishCamera(
  desired: boolean,
  publication: CameraPublicationSnapshot | undefined,
): boolean {
  if (!desired) return false;
  return !publication
    || publication.muted
    || !publication.trackPresent
    || publication.trackReadyState === 'ended';
}
